<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space"><span class="text">{{ msgAlerta }}</span></div>

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Ano/Mês</label>
                <div class="field-label field-label-center">{{ objEdicao.anomes }}</div>
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center">{{ objEdicao.protocolo }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Responsável</label>
                <div class="field-label">{{ globalStore.nmusuario }}</div>
            </div>
        </div>


        <div v-if="!modoItens">
            <div class="row-end">
                <button v-if="objEdicao.anomes != 0" class="btn-confirm" @click="salvarCabecalho">Iniciar Preenchimento</button>
                <button @click="closeForm">Retornar</button>
            </div>
        </div>
        
    
    
        <div v-if="modoItens">
            <div class="row row-space">
                <ProdutoMapaSelect class="form-item" v-model="produtoSelecionado" />

                <div class="form-item-char20">
                    <label class="label-caption">Quantidade</label>
                    <input type="text" class="input-right" v-model="edQuantidade" v-decimal-mask maxlength="10"/>
                </div>

                <div class="form-item-char15">
                    <UnidadeMedidaSelect v-model:unidadeSelecionada="unidadeSelecionada" />
                </div>

                <div class="form-item-char30">
                    <label class="label-caption">Lote</label>
                    <input type="text" class="input-center" v-model="edLote" maxlength="100" v-uppercase />
                </div>
            </div>

            <div class="row">
                <div class="form-item">
                    <label class="label-caption">Nome Comercial</label>
                    <input type="text" v-model="edNmComercial" maxlength="100" v-uppercase />
                </div>

                <button class="btn-confirm" @click="salvarItem">Salvar Ítem</button>
                <button class="btn-cancel" @click="abrirModal">Encerrar e Assinar</button>
                <button @click="closeForm">Sair</button>
            </div>            
        </div>
    </div>

    <div v-if="modoItens">
        <table>
            <thead>
                <tr>
                    <th class="col-width-char10">Produto</th>
                    <th>Descrição</th>
                    <th class="col-width-char20">Unidade</th>
                    <th class="col-width-char20">Quantidade</th>
                    <th class="col-width-char20">Lote</th>
                    <th class="col-width-char05"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsItens" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char10 right">{{ obj.cdproduto }}</td>
                    <td>{{ obj.nmproduto }}</td>
                    <td class="col-width-char20 center">{{ obj.unidade }}</td>
                    <td class="col-width-char20 right">{{ formatDecimal(obj.qtd) }}</td>
                    <td class="col-width-char20 center">{{ obj.lote }}</td>
                    <td class="col-width-char05"><div class="row-left">
                        <button class="btn-icon btn-icon--trash" @click="excluiItem(obj)"></button>
                    </div></td>
                </tr>
            </tbody>
        </table>
    </div>

    <ConfirmModal ref="confirmModal" />

    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closeForm" 
        @confirmed="closeForm" />

    <SenhaModal ref="senhaModalRef" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { criarPlaProducao } from '@/models/plaproducao';
import { decimalFromString, formatDecimal } from '@/funcoes/utils';
import { genericDelete, genericGet, genericPost, genericPut } from '@/funcoes/api';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import ProdutoMapaSelect from '@/selects/ProdutoMapaSelect.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';
import UnidadeMedidaSelect from '@/selects/estaticos/UnidadeMedidaSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const ckEmiteSalvo = ref(false);
const confirmModal = ref(null);
const edLote = ref(null);
const edNmComercial = ref(null);
const edQuantidade = ref(null);
const isLoading = ref(false);
const lsItens = ref([]);
const modoItens = ref(false);
const msgAlerta = ref(null);
const msgOkModal = ref('Planilha encerrada e homologada com sucesso.');
const objAssinatura = ref(criarAssinatura());
const objEdicao = ref(criarPlaProducao());
const produtoSelecionado = ref(null);
const showOkModal = ref(false);
const unidadeSelecionada = ref(null);


async function abrirModal() {
    encerrarDigitacao();
}

const closeForm = () => {
    if (ckEmiteSalvo.value) emit('save');
    emit('close'); 
}

async function encerrarDigitacao(){
    try{
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        isLoading.value=true;
        
        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:PLAPRODUCAO|IDREF:${objEdicao.value.id}|PROT:${objEdicao.value.protocolo}`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objEdicao.value.id;
        objAssinatura.value.doc_tipo = 'PLAPRODUCAO';

        const respAss = await Api.genericPut('/pla/plaproducao/homologar', objAssinatura.value);
        if (respAss.bolok === 1){
            ckEmiteSalvo.value=true;
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

const excluiItem = async(item) => {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma exclusão do ítem?',
        confirmText: 'Sim',
        cancelText: 'Não'
    });
    if (confirmado){
        try{
            msgAlerta.value=null;
            isLoading.value=true;
            await genericDelete({id: item.id, strparam1: 'plaproducao_itens', idusuario: globalStore.idusuario});
            await lerItens();
        } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
        }finally{isLoading.value=false;}
    }
}

const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        let req=null;
        if (props.idEdicao==0){
            req = await genericGet('/pla/plaproducao_new', {idestabelecimento: globalStore.idestabelecimento});
            Object.assign(objEdicao.value, req);
        }else{
            req = await genericGet('/cad/plaproducao', {id: props.idEdicao});
            Object.assign(objEdicao.value, req[0]);
            modoItens.value=true;
            await lerItens();
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}
};

async function lerItens(){
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        const itens = await genericPost('/lspla/plaproducao/itens', {id: objEdicao.value.id});
        lsItens.value = itens;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}

const salvarItem = async () => {
    try {
        if (!produtoSelecionado.value) throw new Error('Informe o produto');
        if (!edQuantidade.value) throw new Error('Informe a quantidade');
        if (!unidadeSelecionada.value) throw new Error('Informe a unidade de medida');
        // Validacoes.validarTexto(edLote.value, 'Informe o lote do ítem');
        isLoading.value = true;
        msgAlerta.value = null;

        const response  = await genericPut('/cad/plaproducao_item', {
            id: 0,
            idprodutomapa: produtoSelecionado.value.id,
            idplaproducao: objEdicao.value.id,
            anomes: objEdicao.value.anomes,
            nmcomercial: edNmComercial.value,
            qtd: decimalFromString(edQuantidade.value),
            unidade: unidadeSelecionada.value,
            lote: edLote.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (response.bolok === 1){
            ckEmiteSalvo.value=true;
            produtoSelecionado.value=null;
            edQuantidade.value = null;
            lerItens();
        }else{
            msgAlerta.value=response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally{isLoading.value=false;}
};

const salvarCabecalho = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const response = await genericPut('/cad/plaproducao', objEdicao.value);
        if (response.bolok === 1){
            if (objEdicao.value.id==0) objEdicao.value.id = response.id;
            ckEmiteSalvo.value=true;
            modoItens.value=true;
            await lerItens();
        }else{msgAlerta.value=`ATENÇÃO: ${response.erro}`;}
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>